export default __webpack_public_path__ + "static/media/logo-black.d4f831b0.svg";